import { deleteRequest, get, post } from "../../helpers/apihelpers";

export const GetTemplateTargetListService=async(page)=>{
    try {
        const result = await get(`api/admin/templatetargetlist/get?page=${page}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetTemplateTargetListDetailService=async(id)=>{
    try {
        const result = await get(`api/admin/templatetargetlist/get_detail/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetTemplateTargetListAnalyticsService=async(id)=>{
    try {
        const result = await get(`api/admin/templatetargetlist/get_analytics/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteTemplateTargetListService=async(id)=>{
    try {
        const result = await deleteRequest(`api/admin/templatetargetlist/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const AssignedFailedTemplateTargetListService=async(id)=>{
    try {
        const result = await post(`api/admin/templatetargetlist/assignFailedData/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}